import { useContext } from "react";

import { HookOutOfContextError } from "@jugl-web/utils";
import { UnreadIndicatorsContext } from "./UnreadIndicatorsContext";

export const useUnreadIndicators = () => {
  const context = useContext(UnreadIndicatorsContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useUnreadIndicators",
      "UnreadIndicatorsContext"
    );
  }

  return context;
};
